
<ng-container *ngIf="isWorkflowOnSubscriber || !isMandatoryDocumentation ">
  <fieldset>
    <div class="row">
      <label for="Campos obrigatórios" style="color:#DB3347"><span class="mandatory"></span>{{'Workflow.Mandatory' | translate}}</label>
      <div class="col-sm-12">
        <h1 class="text-primary mb-4">{{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.TitlePrestage' | translate}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <documentation-help></documentation-help>
      </div>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col-sm-6">
        <h2 class="text-primary mb-0">

          <span>{{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.TitleCard' | translate}}</span>
        </h2>
      </div>

      <div class="col-sm-6 text-end" *ngIf="showAddDocButton ||  (stateCode==StateCode.Ativo && statePhase == StatePhase.DevolvidoAoRemetente)">
        <button (click)="expandNewEntry=!expandNewEntry"
            
                [ngClass]="!expandNewEntry  ? '' : 'disabled'"
                type="button"
                aria-label="Nova entrada"
                class="btn btn-link disable-on-fieldset">
          <span class="icon-add"></span> <span>{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</span>
          <!--<span>{{ stateCode!=StateCode.Ativo && statePhase != StatePhase.DevolvidoAoRemetente}}</span>-->
        </button>
      </div>
    </div>

    <!--New table entry inputs-->
    <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
      <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
        <span aria-hidden="true" class="icon-close text-primary"></span>
      </button>
      <h3 class="text-primary">{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</h3>
      <documentation-table-edit-pm-pre-stage [instanceRole]="instanceRole"
                                             [isWorkflowMandatory]="isWorkflowMandatory" [itemList]="model.documentsList"
                                             [beneficiaryList]="beneficiaryList"
                                             [senderIdentification]="senderIdentification"
                                             [deceasedIdentification]="deceasedIdentification"
                                             [dropdowns]="dropdowns"
                                             (listChanged)="onDocumentationChanged($event)"
                                             [workflowInstanceId]="workflowInstanceId"
                                             [isMandatoryDocumentation]="isMandatoryDocumentation"
                                              [isDiferida]="false"
                                              [stateCode]="stateCode"
                                              [statePhase]="statePhase"
                                             [isWorkflowOnSubscriber]="isWorkflowOnSubscriber" [isIncapacity]="isWorkflowIncapacity">

      </documentation-table-edit-pm-pre-stage>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th scope="col">
            {{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.Designation' | translate}}
            <span class="ml-1 text-primary icon-help"
                  aria-label="Tooltip com informação" tooltip="{{'Tooltips.Documents.Designation' | translate}}">
            </span>
          </th>
          <th scope="col">{{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.Owner' | translate}}</th>
          <th scope="col">{{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.NameCodigo' | translate}}</th>
          <th scope="col">Ficheiro</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let tableItem of model.documentsList; let i = index">
          <tr [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)" *ngIf="isNotRLDeferidaAndHasDocument(tableItem)">
            <td style="color:red;font-size:2rem;padding-top:6px;text-align:center;">{{markAsMandatory(tableItem)? '*' : ''}}</td>
            <td>{{tableItem.description}}</td>

            <td>{{tableItem.ownerName }} </td>
            <td>{{tableItem.fileDescription}}</td>
            <td>{{tableItem.fileName}}</td>
            <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
              <button type="button" class="btn-icon" aria-label="Editar"
                      [tooltip]="getTooltipBasedOnDocRL(tableItem)"
                      placement="left"
                      [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic"
                      *ngIf="tableItem.isDocumentValidated==false || tableItem.isDocumentValidated==null">
                <span class="p-1" *ngIf="!readonlyAdditionalDoc" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : getIconBasedOnDocRL(tableItem)"></span>
              </button>
            </td>
          </tr>
          <tr *ngIf=" (expandedRowIndex == i)" [collapse]="expandedRowIndex != i" [isAnimated]="false">
            <td class="p-0" colspan="5" id="collapseBasic">
              <div class="ml-5 mr-5 p-4">
                <documentation-table-edit-pm-pre-stage [itemList]="model.documentsList"
                                                       [instanceRole]="instanceRole"
                                                       [editIndex]="i" (listChanged)="onDocumentationChanged($event)"
                                                       [beneficiaryList]="beneficiaryList"
                                                       [senderIdentification]="senderIdentification"
                                                       [deceasedIdentification]="deceasedIdentification"
                                                       [dropdowns]="dropdowns"
                                                       [isMandatoryDocumentation]="userSendingClinicalDocs" [isWorkflowOnSubscriber]="isWorkflowOnSubscriber"
                                                       [isIncapacity]="isWorkflowIncapacity" [isReadonly]="readonlyAdditionalDoc" [workflowInstanceId]="workflowInstanceId"
                                                       [isDiferida]="getBeneficiaryRLFromDocument(tableItem) == LegalRepresentationState.RepresentacaoDeferida"
                                                       [stateCode]="stateCode"
                                                       [statePhase]="statePhase"
                                                       [isWorkflowMandatory]="isWorkflowMandatory">

                </documentation-table-edit-pm-pre-stage>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </fieldset>


  <br /><br />
</ng-container>
<!--<pre>{{cardData | json}}</pre>-->
